import { createRouter, createWebHashHistory } from 'vue-router';
import { jwtDecode as decode } from 'jwt-decode';

const routes = [
    {
    path: '/',
    name: 'Casos',
    component: () => import('@/caso/page/DenunciaWeb.vue'),
    meta: { layout: 'default', requiresAuth: true }
  }, 
  {
    path: '/verificador',
    name: 'Verificador',
    component: () => import('@/caso/page/LectorQR.vue'),
    meta: { layout: 'default', requiresAuth: true }
  }, 
  {
    path: '/genera',
    name: 'Genera',
    component: () => import('@/caso/page/Genera.vue'),
    meta: { layout: 'default', requiresAuth: true }
  }, 

];


const router = createRouter({
  //history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(`${process.env.VUE_APP_BASE_URL}`),
  //history: createWebHashHistory(process.env.BASE_URL),
  routes,
})
export default router;
